import React, { ReactNode } from 'react';

const EEPlaceholder: React.FC<{ id?: string; children?: ReactNode }> = ({ id, children }) => {
  return (
    <section id={id} className="ee-placeholder">
      {children}
    </section>
  );
};

export default EEPlaceholder;
